import {
  GETOPERATIONLIST_SUCCESS,
  GETOPERATIONLIST_FAILED,
  RESET_GETOPERATIONLIST,
  LOADING_GETOPERATIONLIST,
  NETWORK_ERROR_UGETOPERATIONLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetOperationList = () => {
  return { type: RESET_GETOPERATIONLIST };
};

const getOperationList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETOPERATIONLIST });
  await partnerServices
    .post("getOperationList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(getOperationListsuccess(res.data));
          break;
        default:
          dispatch(getOperationListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_UGETOPERATIONLIST, payload: err });
    });
};
function getOperationListsuccess(data) {
  return {
    type: GETOPERATIONLIST_SUCCESS,
    payload: data,
  };
}
function getOperationListFailed(data) {
  return {
    type: GETOPERATIONLIST_FAILED,
    payload: data,
  };
}

export { resetGetOperationList, getOperationList };
